import { LegalLayout, H2, H3 } from "./LegalLayout";
import { seller, stand } from "./legalConfig";

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung" testid="datenschutz-page">
      <H2>1. Verantwortlicher</H2>
      <p>
        Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
        <br />
        {seller.name}, {seller.street}, {seller.zip} {seller.city}, {seller.country}
        <br />
        E-Mail:{" "}
        <a href={`mailto:${seller.email}`} className="text-emerald-700 underline">
          {seller.email}
        </a>
      </p>

      <H2>2. Grundsatz: Datensparsamkeit & keine dauerhafte Speicherung von Inhalten</H2>
      <p>
        {seller.brand} ist auf datensparsame, weitgehend anonyme Nutzung ausgelegt. Für den
        kostenlosen Score-Check ist keine Registrierung und keine Angabe personenbezogener
        Daten erforderlich; die eingegebenen Angaben zur Geschäftsidee sind freiwillig.
        <br />
        <br />
        Die von Ihnen eingegebenen Inhalte (Geschäftsidee, Formularantworten,
        Erstbewertung und der erstellte Bericht) werden nach der Bereitstellung
        <strong> nicht dauerhaft gespeichert</strong>. Sie werden nur für ein kurzes
        Download-Zeitfenster von <strong>24 Stunden</strong> technisch vorgehalten und
        anschließend automatisch und unwiderruflich gelöscht. Nach Ablauf dieses Fensters
        ist kein erneuter Abruf und keine Wiederherstellung mehr möglich. Bitte laden Sie
        Ihren Bericht daher zeitnah herunter bzw. sichern Sie die per E-Mail zugestellte
        PDF-Datei.
      </p>

      <H2>3. Verarbeitung im Einzelnen</H2>

      <H3>a) Formulardaten zur Geschäftsidee</H3>
      <p>
        Die im mehrstufigen Formular eingegebenen Angaben (z. B. Standort, Status, Branche,
        Beschreibung der Idee, Kapital, Kennzahlen) werden zur Erstellung der
        KI-Erstbewertung und des kostenpflichtigen Berichts verarbeitet.
        <br />
        Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Durchführung vorvertraglicher
        Maßnahmen bzw. des Vertrags) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
        Interesse an der Bereitstellung des Dienstes).
      </p>

      <H3>b) Verarbeitung durch KI-Dienstleister</H3>
      <p>
        Zur Erstellung der Auswertungen werden die Formularinhalte an einen
        KI-Sprachmodell-Anbieter (OpenAI, OpenAI, L.L.C., USA) übermittelt; die Übermittlung
        erfolgt über einen technischen Infrastruktur-Dienstleister, der die Anfrage in
        unserem Auftrag weiterleitet. Eine Übermittlung in Drittländer (insb. USA) kann
        erfolgen; diese ist durch geeignete Garantien (EU-Standardvertragsklauseln)
        abgesichert. Es werden keine Klarnamen, Rechnungs- oder Kontaktdaten an den
        KI-Anbieter übermittelt, sofern Sie diese nicht selbst im Freitext angeben. Die an
        die KI übergebenen Inhalte werden bei uns nicht dauerhaft gespeichert (siehe Ziff.
        2).
        <br />
        Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
      </p>

      <H3>c) Zahlungsabwicklung (PayPal / Stripe)</H3>
      <p>
        Bei einem Kauf wird die Zahlung wahlweise über PayPal (PayPal (Europe) S.à r.l. et
        Cie, S.C.A., Luxemburg) oder über Stripe (Stripe Payments Europe, Ltd., Irland)
        abgewickelt. Die für die Zahlung erforderlichen Daten geben Sie direkt beim
        jeweiligen Zahlungsdienstleister ein; es gelten dessen Datenschutzbestimmungen. Wir
        erhalten von diesen Diensten lediglich die zur Zuordnung und Buchung erforderliche
        Zahlungsreferenz und den Zahlungsstatus.
        <br />
        Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
      </p>

      <H3>d) Rechnungsstellung</H3>
      <p>
        Zur Erstellung einer gesetzeskonformen Rechnung (§ 14 UStG) verarbeiten wir die von
        Ihnen angegebenen Rechnungsdaten (Name, Anschrift, E-Mail). Diese Daten unterliegen
        den steuer- und handelsrechtlichen Aufbewahrungsfristen (bis zu 10 Jahre, § 147 AO)
        und sind von der Löschung nach Ziff. 2 ausgenommen.
        <br />
        Rechtsgrundlage: Art. 6 Abs. 1 lit. c DSGVO (rechtliche Verpflichtung).
      </p>

      <H3>e) E-Mail-Versand des Berichts / der Rechnung</H3>
      <p>
        Sofern Sie im Formular ausdrücklich einwilligen, senden wir Ihnen Ihren Bericht
        zusätzlich per E-Mail an die von Ihnen angegebene Adresse zu. Bei kostenpflichtigen
        Berichten versenden wir zudem die Rechnung per E-Mail. Für den technischen
        E-Mail-Versand nutzen wir den Dienstleister Resend (Resend, Inc., USA) als
        Auftragsverarbeiter. Die Inhalte werden dort nur temporär zum Zweck der Zustellung
        verarbeitet und von uns nicht dauerhaft gespeichert.
        <br />
        Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) bzw. Art. 6 Abs. 1 lit.
        b/c DSGVO (Vertrag/Rechnung). Eine erteilte Einwilligung können Sie jederzeit mit
        Wirkung für die Zukunft widerrufen.
      </p>

      <H3>f) Speicherung & Löschung der Berichte</H3>
      <p>
        Abweichend von einer dauerhaften Archivierung werden Bericht und zugehörige
        Eingaben ausschließlich für das in Ziff. 2 genannte 24-Stunden-Download-Fenster
        vorgehalten und danach automatisch gelöscht. Ein späterer erneuter Abruf oder ein
        automatischer Neuversand findet nicht statt.
      </p>

      <H3>g) Datensparsamer Support-Nachweis</H3>
      <p>
        Bei kostenpflichtigen Käufen speichern wir zu Nachweis- und Supportzwecken einen
        stark reduzierten Datensatz, der <strong>keine inhaltlichen Angaben</strong> zu
        Ihrer Geschäftsidee oder Ihrem Bericht enthält – lediglich eine nicht erratbare
        Support-Kennung, die Zahlungsreferenz und den Zahlungsstatus, Zeitstempel, den
        Erstellungs-, Download- und Versandstatus sowie ggf. einen technischen Fehlercode.
        <br />
        Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
        Nachweisbarkeit und Support) sowie Art. 6 Abs. 1 lit. c DSGVO, soweit
        Aufbewahrungspflichten bestehen.
      </p>

      <H2>4. Hosting, Plattform & Server-Logs</H2>
      <p>
        Die Anwendung wird auf einer Cloud-Infrastruktur betrieben. Beim Aufruf der Website
        werden durch den Hosting-/Plattform-Anbieter automatisch technische Zugriffsdaten
        (z. B. IP-Adresse, Zeitpunkt, abgerufene Seite, Browsertyp) in Server-Logfiles
        verarbeitet. Dies dient der technischen Bereitstellung und Sicherheit. Zusätzlich
        wird ein technisches Plattform-Skript des Infrastruktur-Anbieters geladen, das für
        den Betrieb der Anwendung erforderlich ist und nicht dem Marketing-Tracking dient.
        <br />
        Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.
      </p>

      <H2>5. Cookies, lokaler Speicher & Schriftarten</H2>
      <p>
        Für normale Besucher setzen wir <strong>keine</strong> Tracking- oder
        Marketing-Cookies und verwenden keinen dauerhaften lokalen Speicher zu
        Marketingzwecken. Ein technisch notwendiges Cookie wird ausschließlich im internen
        Verwaltungsbereich (Admin-Login) zur Sitzungsverwaltung gesetzt und betrifft normale
        Nutzer nicht.
        <br />
        <br />
        Die verwendeten Schriftarten werden <strong>lokal von unserem eigenen Server</strong>
        ausgeliefert (Self-Hosting). Es findet dabei <strong>keine Verbindung zu Google-
        Servern</strong> und keine Übermittlung Ihrer IP-Adresse an Dritte zum Laden von
        Schriftarten statt.
        <br />
        Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer
        einheitlichen, sicheren Darstellung).
      </p>

      <H2>6. Ihre Rechte</H2>
      <p>
        Sie haben nach der DSGVO das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16),
        Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit
        (Art. 20) sowie Widerspruch (Art. 21). Zur Ausübung genügt eine formlose E-Mail an{" "}
        <a href={`mailto:${seller.email}`} className="text-emerald-700 underline">
          {seller.email}
        </a>
        . Bitte beachten Sie, dass inhaltliche Bericht- und Formulardaten aufgrund der
        automatischen Löschung nach 24 Stunden (Ziff. 2) regelmäßig nicht mehr vorliegen.
      </p>

      <H2>7. Beschwerderecht bei einer Aufsichtsbehörde</H2>
      <p>
        Ihnen steht ein Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde zu,
        insbesondere am Ort Ihres gewöhnlichen Aufenthalts oder unseres Sitzes.
      </p>

      <p className="text-xs text-slate-400 pt-6">Stand: {stand}</p>
    </LegalLayout>
  );
}
